import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import NotFound from '@/pages/NotFound';
import { GUIDE_CONTENT } from './guideContent';

/**
 * /guide/:topic — 이용안내 하위 페이지.
 * 각 항목의 인포그래픽 컴포넌트를 렌더한다. (제목은 각 컴포넌트 헤더가 담당)
 */
const GuidePage = () => {
  const { topic } = useParams<{ topic: string }>();
  const guide = topic ? GUIDE_CONTENT[topic] : undefined;

  if (!guide) return <NotFound />;

  return (
    <Center>
      <Inner>{guide.render()}</Inner>
    </Center>
  );
};

export default GuidePage;

const Center = styled.div`
  display: flex;
  justify-content: center;
`;

const Inner = styled.div`
  width: 100%;
  max-width: 1024px;
  /* 모바일 좌우 패딩 + 하단(푸터) 간격 확보 */
  padding: 32px 20px 64px;

  @media (max-width: 480px) {
    padding: 20px 16px 48px;
  }
`;
